import React from 'react';
import NonMemberContext from '@icoach/nonMember/components/NonMemberContext';
export default function useNonMember() {
    return React.useContext(NonMemberContext);
}
